import { render, staticRenderFns } from "./ToothMap.vue?vue&type=template&id=143330a0&"
import script from "./ToothMap.vue?vue&type=script&lang=js&"
export * from "./ToothMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports